import type { HeaderProps } from "@whatslly/types/UI-V2/HeaderType";
import classnames from "classnames";
import upperFirst from "lodash/upperFirst";
import { observer } from "mobx-react-lite";
import React from "react";
import globalStyles from "../globalStyles";
import styles from "./header.module.scss";

export const Header: React.FC<HeaderProps> = observer(({ children, ...props }) => {
  return (
    <p
      className={classnames(
        globalStyles[`pi-${props.paddingInline ?? "default"}`],
        globalStyles[`text-align-${props.textAlign ?? "center"}`],
        globalStyles[`fw-${props.fontWeight ?? "default"}`],
        globalStyles[`mt-${props.marginTop ?? "none"}`],
        globalStyles[`mb-${props.marginBottom ?? "small"}`],
        globalStyles[`fs-${props.fontSize ?? "default"}`],
        globalStyles[`color-${props.color ?? "main-primary"}`],
        { [styles.underLine]: props.underLine }
      )}
    >
      {props.text ? upperFirst(props.text) : children}
    </p>
  );
});
